/* @ngInject */

export default function UserMenu($templateCache) {
	var templateString = $templateCache.get('templates/user-menu-tmpl.html');

	return {
		scope: {
			menus: '@',
			fullname: '=',
			onLinkClick: '&onClick'
		},
		template: templateString,
		//templateUrl: "templates/user-menu-tmpl.html",
		link: userMenuLink
	};
}

function userMenuLink(scope, element, attrs) {
	var $element = $(element);
	var $ul = $('ul#userMenuItems', $element);
	var menus = JSON.parse(attrs.menus);
	var $li;
	var $linkTag;
	var $dropDownIcon = $($('a#title i', $element)[1]);

	angular.forEach(menus, function(menu) {
		var menuItem;
		if (menu) {
			if (menu.trim() === '-' || menu.toLowerCase().trim() === 'divider') {
				menuItem = "<li class='divider'><hr /></li>";
			} else {
				menuItem = "<li><a href='#' class='documents'>" + menu + '</a></li>';
			}
			$ul.append(menuItem);
		}
	});
	$ul.append('<li><a href="">Logout</a></li>');

	$li = $('li', $ul);
	$linkTag = $('a', $li);

	$('a', $element).on('click', function(evt) {
		var clickedTag = evt.target.tagName.toLowerCase();
		if (evt.target.id === 'title' || clickedTag === 'i' || clickedTag === 'label') {
			if ($ul.css('opacity').toString() === '1') {
				hideMenu();
			} else {
				showMenu();
			}
		} else {
			scope.onLinkClick({ $event: evt });
			hideMenu();
		}

		scope.$broadcast('client-navigation-changed', { path: 'my-profile' });
	});

	function showMenu() {
		$ul.css('opacity', 1);
		$li.css('height', '36px').css('overflow', 'visible').css('padding', 0);
		$linkTag.css('display', 'inline-block');

		$dropDownIcon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
	}

	function hideMenu() {
		$ul.css('opacity', 0);
		$li.removeAttr('style');
		$linkTag.css('display', 'none');

		$dropDownIcon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
	}

	scope.$on('user-profile-updated', function($event, updatedUser) {
		scope.title = updatedUser.FullName;
	});
}
